import React from "react";
import {Modal, Spinner} from "react-bootstrap";
import PropTypes from "prop-types";

const Loader = props => {
    return (
        <Modal
            className="modal-spinner-container"
            show={props.show}
            centered
            contentClassName="modal-spinner"
        >
            <Modal.Body>
                <Spinner animation="border" size="xl" aria-hidden="true" role="status"/>
                <span className="visually-hidden">Loading...</span>
            </Modal.Body>
        </Modal>
    )
};

Loader.propTypes = {
    show: PropTypes.bool
};

export default Loader;